<template>
  <article class="third-party-list">
    <div class="publication-dates">
      <div>更新日期：{{ content.updatedAt }}</div>
      <div>发布日期：{{ content.publishedAt }}</div>
      <div>生效日期：{{ content.effectiveAt }}</div>
    </div>
    <p v-for="(paragraph, index) in content.introduction" :key="index">
      {{ paragraph }}
    </p>
    <section v-for="(service, index) in content.services" :key="service.name">
      <h3>{{ index + 1 }}. 第三方服务：{{ service.name }}</h3>
      <p><strong>收集个人信息目的/用途：</strong>{{ service.purpose }}</p>
      <p><strong>收集个人信息类型：</strong>{{ service.information }}</p>
      <p>
        <strong>第三方隐私协议链接：</strong
        ><span class="privacy-url">{{ service.privacyUrl }}</span>
      </p>
      <p><strong>提供方：</strong>{{ service.provider }}</p>
    </section>
  </article>
</template>

<script>
import content from "./thirdPartyContent";
export default {
  data() {
    return { content };
  },
};
</script>

<style scoped>
.third-party-list {
  padding: 20px 16px 32px;
  background: #fff;
  color: #222;
  font-size: 14px;
  line-height: 1.8;
  overflow-wrap: break-word;
}
.publication-dates {
  margin-bottom: 24px;
  line-height: 1.55;
}
p {
  margin: 0 0 16px;
}
section {
  margin-top: 26px;
}
h3 {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.8;
  font-weight: 600;
}
strong {
  font-weight: 600;
}
.privacy-url {
  word-break: break-all;
}
</style>
